const PROXY_ROOT = '/proxy';

/**
 * Recherche d'entreprises API endpoint
 * @see https://recherche-entreprises.api.gouv.fr
 */
export const RECHERCHE_ENTREPRISES_API_PROXY_ENDPOINT = `${PROXY_ROOT}/recherche-entreprises-api`;
